<div class="row margin-0 margin-bottom-30 margin-top-5 loader-position ng-star-inserted">
  <div class="col-12 text-center ">
    <span class="text-dark-gray st-h7 ">
      Logging out...
    </span>
  </div><div class="margin-auto"></div><div class="margin-auto padding-top-10"><span class="loading-spin"></span></div>
</div>
